import {
  addUserVoting,
  loggedIn,
  addNewVoting,
  importVotingUsers,
  importVotingCandidates,
  getEventVoting,
  updateNewVoting,
  getVoteInfo,
  getRateResult,
  getPresentsStatus
} from '@/api/voting'

const voting = {
  state: {},

  mutations: {},

  actions: {
    addUserVoting({commit}, data) {
      return new Promise((resolve, reject) => {
        addUserVoting(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    loggedIn({commit}, data) {
      return new Promise((resolve, reject) => {
        loggedIn(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    addNewVoting({commit}, data) {
      return new Promise((resolve, reject) => {
        addNewVoting(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    importVotingUsers({commit}, data) {
      return new Promise((resolve, reject) => {
        importVotingUsers(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    importVotingCandidates({commit}, data) {
      return new Promise((resolve, reject) => {
        importVotingCandidates(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getEventVoting({commit}, data) {
      return new Promise((resolve, reject) => {
        getEventVoting(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    updateNewVoting({commit}, data) {
      return new Promise((resolve, reject) => {
        updateNewVoting(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getVoteInfo({commit}, data) {
      return new Promise((resolve, reject) => {
        getVoteInfo(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getRateResult({commit}, data) {
      return new Promise((resolve, reject) => {
        getRateResult(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getPresentsStatus({commit}, data) {
      return new Promise((resolve, reject) => {
        getPresentsStatus(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
}

export default voting
